import { Avatar } from '@creditornot/cb-avatar';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';

type ResultProps = {
  onClick?: () => void | undefined;
  label: string;
  subLabel?: string;
  listImage?: string;
  tag?: string;
  disabled?: boolean;
};

export const getInitialsFromLabel = (label: string): string => label.charAt(0);

const EntityLabel = styled.div`
  ${typographyCss.Body3};
`;

const EntityDescription = styled.div`
  ${typographyCss.Body3};
  color: ${cssThemedValue('textSecondary')};
`;

const StyledMenuActionItem = styled(MenuActionItem)`
  padding: 4px, 32px, 4px, 8px;
  height: 40px;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledAvatar = styled(Avatar)`
  height: 24px;
  width: 24px;

  img {
    object-fit: cover;
  }
`;

export const Result: React.FunctionComponent<ResultProps> = ({
  label,
  onClick,
  subLabel,
  listImage,
  tag,
  disabled,
}: ResultProps) => {
  const initials = getInitialsFromLabel(label);

  return (
    <StyledMenuActionItem
      disabled={disabled}
      variant="black"
      leftContent={<StyledAvatar size="small" imgSrc={listImage} initials={initials} />}
      onClick={onClick}
    >
      <ContentContainer>
        <LabelsContainer>
          <EntityLabel>{label}</EntityLabel>
          <EntityDescription>{subLabel}</EntityDescription>
        </LabelsContainer>

        {tag?.length && (
          <Tag variant="lightBlack" size="small">
            {tag}
          </Tag>
        )}
      </ContentContainer>
    </StyledMenuActionItem>
  );
};
